import { createAccountUsersAccountsPath } from "src/routes";
import { submitRequiringPhoneVerification } from "src/customer/phone_verified_submission";

const createAccount = (formData: FormData) => submitRequiringPhoneVerification(createAccountUsersAccountsPath(), formData);

export { createAccount }
